import { configureStore } from '@reduxjs/toolkit';
import blogsReducer from './blogsSlice';
import galleryReducer from './gallerySlice';

export const store = configureStore({
  reducer: {
    blogs: blogsReducer,
    gallery: galleryReducer,
  },
});

export default store;
